import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../../../stem-core/src/state/StoreField.js";
import {Money} from "../../../stem-core/src/localization/Money.js";


class MerchantRevenue extends StoreObject {
    @field("Currency") currency;
    @field(Money) outstandingBalance;
    @field(Money) allTimeRevenue;
    @field(Money) last24hRevenue;
    @field(Money) last30dRevenue;
}

const MerchantRevenueStore = MakeStore("MerchantRevenue", MerchantRevenue);

export {MerchantRevenueStore};
